import {State} from '../../../types/mx/reducers';
import {LoanApplicationsItemState} from '../types/reducers';

export const mapStateToLoanApplicationsItem = (state: State): LoanApplicationsItemState => {
    const loanApplications = state.commonLoanApplication.loanApplications;
    return Object.keys(loanApplications.byId)
        .map(i => (loanApplications.byId[i]))
        .find(item => item.selected);
};

export const mapStateToToken = (state: State): string => {
    const loanApplicationItemSelected = mapStateToLoanApplicationsItem(state);
    return loanApplicationItemSelected ? loanApplicationItemSelected.token : '';
};

export const mapStateToLoanId = (state: State): string => {
    const loanApplicationItemSelected = mapStateToLoanApplicationsItem(state);
    return loanApplicationItemSelected ? loanApplicationItemSelected.hash : '';
};

export const mapStateToLoanTarget = (state: State): string => {
    const loanApplicationItemSelected = mapStateToLoanApplicationsItem(state);
    return loanApplicationItemSelected ? loanApplicationItemSelected.target
        ? loanApplicationItemSelected.target.id : '' : '';
};